import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function GlassCard({ children, className, hover = false, ...props }) {
  return (
    <motion.div
      className={cn(
        "glass rounded-2xl shadow-sm",
        hover && "transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg",
        className
      )}
      {...props}
    >
      {children}
    </motion.div>
  );
}
